import { $ } from '../../utils/jquery.js';
import { freeze, unfreeze } from "../../scripts/freeze";

$(document).on("click", "[data-tab-target]", function (e) {
  e.preventDefault();

  const button = $(this);
  const targetTab = button.data("tab-target");
  const tab = $(document).find(`[data-tab="${targetTab}"]`);
  const tabGroup = tab.data("tab-group");
  const tabGroupMembers = $(document).find(`[data-tab-group="${tabGroup}"]`);
  const activeClass = "is-active";
  const burgerHeaderElement = $(".js-burger-menu-header");
  const scroller = $(".js-burger-wrapper");
  const text = $(this).find('.burger-menu-eshop-main__link-text').text();

  if (text) {
    $('.burger-menu-header__back-link-text').text(text);
  }

  if (targetTab.includes("eshop-category-")) {
    burgerHeaderElement.addClass("is-subcategory");
  } else {
    burgerHeaderElement.removeClass("is-subcategory");
  }

  button.addClass(activeClass).siblings().removeClass(activeClass);
  tabGroupMembers.hide().removeClass(activeClass);

  tab.show(0, function () {
    scroller.scrollTop(0);
    $(this).addClass(activeClass);
  });
});

function toggleBurgerMenu() {
  const burgerMenu = $(".js-burger-menu");
  const isActive = burgerMenu.hasClass("is-active");
  const scroller = $(".js-burger-wrapper");

  if (isActive) {
    burgerMenu.removeClass("is-visible");
    setTimeout(() => {
      burgerMenu.hide().removeClass("is-active");
      burgerMenu.find("[data-tab-target='eshop-main']").click();
      unfreeze();
    }, 300);
    return;
  }

  burgerMenu.show(0, () => {
    burgerMenu.addClass("is-active");
    scroller.scrollTop(0);
    freeze();
    setTimeout(() => {
      burgerMenu.addClass("is-visible");
    }, 1);
  });
}

$(document).on("click", ".js-burger-toggle", toggleBurgerMenu);
